import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    font-size: 160px;
    justify-content: space-between;
`;